var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-banner',{attrs:{"outlined":"","type":""}},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option}}),_vm._v(" "+_vm._s(this.directivesByDesignations.directivesImplementationByDesignations)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }